import type { ReactNode } from "react";
import { Card } from "./Card";

/**
 * A single dashboard stat: icon, sentence-case label, and a precise value.
 * Values here are exact on-chain BTC amounts (not compact-notation KPIs),
 * so the value stays monospace/full-precision rather than "12.9K"-style —
 * see MissingWordsForm etc. for the same font-mono-for-precision convention
 * used throughout this app.
 */
export function StatTile({ icon, label, value, accent = "ledger" }: { icon: ReactNode; label: string; value: ReactNode; accent?: "ledger" | "signal" | "muted" }) {
  const iconTone =
    accent === "signal" ? "bg-signal-500/15 text-signal-400" : accent === "muted" ? "bg-ink-700 text-muted" : "bg-ledger-500/15 text-ledger-400";

  return (
    <Card padding="md" className="flex items-start gap-3">
      <span className={`shrink-0 flex items-center justify-center w-9 h-9 rounded-md ${iconTone}`}>{icon}</span>
      <span className="min-w-0">
        <span className="block text-xs text-muted">{label}</span>
        <span className="block mt-0.5 font-mono text-sm text-paper truncate">{value}</span>
      </span>
    </Card>
  );
}
